import React from 'react';
import Assets from '../constants/images';
import ThemeButton from '../components/buttons/ThemeButton';
import { useNavigate } from 'react-router-dom';
import { link } from '../constants/appConstants';

const NotFound = () => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(link.dashboard);
  };

  return (
    <div className="w-full h-screen flex flex-col justify-center items-center pages not-found-page">
      <img className="w-96 h-96 object-cover" src={Assets.NotFound} alt="" />
      <ThemeButton
        onClick={handleGoBack}
        type="button"
        className="w-52"
        text="Go Back"
        loading={false}
      />
    </div>
  );
};

export default NotFound;
